module.exports = __webpack_public_path__ + "static/media/server.7ae69c9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/server.svg
// module id = 99
// module chunks = 0